import cn from 'classnames';

import type { IParticipantsImportStat } from '@/api/endpoints/schools/schoolParticipants';

import styles from './ImportsStat.module.scss';

interface IProp {
  stats: IParticipantsImportStat;
}

export const ImportsStat = ({
  stats: { total, succeed, with_errors: withErrors, total_memberships: totalMemberships },
}: IProp) => (
  <div className={styles.wrapper}>
    <div className={styles['stat-wrapper']}>
      <p className={styles['stat-title']}>Всего импортов</p>
      <p className={styles['stat-value']}>{total}</p>
    </div>
    <div className={styles['stat-wrapper']}>
      <p className={styles['stat-title']}>Успешных</p>
      <p className={cn(styles['stat-value'], styles['stat-value-succeed'])}>{succeed}</p>
    </div>
    <div className={styles['stat-wrapper']}>
      <p className={styles['stat-title']}>С ошибками</p>
      <p className={cn(styles['stat-value'], styles['stat-value-failed'])}>{withErrors}</p>
    </div>
    <div className={styles['stat-wrapper']}>
      <p className={styles['stat-title']}>Всего участников</p>
      <p className={cn(styles['stat-value'], styles['stat-value-total-memberships'])}>{totalMemberships}</p>
    </div>
  </div>
);
